import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./MonComptePage.module.css";
import { useAuth } from "../contexts/AuthContext";
import archiveStyle from "../styles/modules/Archives.module.css";
import Breadcrumbs from "../components/common/Breadcrumbs";
import AccountNav from "components/navigation/AccountNav";
import AccountInfo from "components/common/AccountInfo";
import AccountReservations from "components/common/AccountReservations";
import AccountTickets from "components/common/AccountTickets";
import AccountStreams from "components/common/AccountStreams";
import AddresseManager from "components/common/AddresseManager";
import { Helmet } from "react-helmet";

const MoncComptePage = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const [screen, setScreen] = useState("informations");

  return (
    <div className={`page-content ${styles.pageContent}`}>
      <Helmet>
        <title>Mon Compte - Pharos</title>
        <meta name="description" content="Gérez votre compte Pharos, vos informations personnelles, adresses et réservations." />
        <meta property="og:title" content="Mon Compte - Pharos" />
        <meta property="og:description" content="Gérez votre compte Pharos, vos informations personnelles, adresses et réservations." />
        <meta property="og:type" content="website" />
      </Helmet>
      <section className={`global-section global-section-title ${styles.section}`}>
        <div className={`global-container ${styles.content}`}>
          <div className={archiveStyle.header}>
            <h1 className="h2">Mon Compte</h1>
            {/* Fil d'Ariane */}
            <Breadcrumbs pageType="isMonCompte" element={{ title: "Mon Compte" }} />
          </div>
        </div>
      </section>
      <section className={`global-section ${styles.section}`}>
        <div className={`global-container ${styles.content}`}>
          <AccountNav onClick={(direction) => {
            setScreen(direction);
          }} />
          {
            (() => {
              switch (screen) {
                case "informations":
                  return <AccountInfo />;
                case "adresses":
                  return <AddresseManager tunnel={false} />;
                case "reservations":
                  return <AccountReservations />;
                case "billets":
                  return <AccountTickets />;
                case "streams":
                  return <AccountStreams />;
                case "deconnexion":
                  return <div>Se déconnecter</div>;
                default:
                  return <AccountInfo />;
              }
            })()
          }
        </div>
      </section>
    </div>
  );
};

export default MoncComptePage;
